import { brand } from '@/config/brands'

const rocnovelFirebaseConfig = {
  apiKey: 'AIzaSyAyzouxR5ypLe6KY55U2rOF6elSm3XdpEw',
  authDomain: import.meta.env.VITE_BIZ_FIREBASE_DOMAIN,
  projectId: 'rocnovel-ecf4b',
  storageBucket: 'rocnovel-ecf4b.firebasestorage.app',
  messagingSenderId: '250984910071',
  appId: '1:250984910071:web:f52bbd8a2ec7f00c0117f2',
  measurementId: 'G-XSELTNYMY0',
}

const superstoryFirebaseConfig = {
  apiKey: 'AIzaSyDgZoBzXuI20Q_gjz_TyNfNOberTq9U5-k',
  authDomain: import.meta.env.VITE_BIZ_FIREBASE_DOMAIN,
  projectId: 'evernovel-bdc4e',
  storageBucket: 'evernovel-bdc4e.firebasestorage.app',
  messagingSenderId: '475775531567',
  appId: '1:475775531567:web:72c83a0e8598259ee2e4da',
  measurementId: 'G-1GG9FHZ3QN',
}

export const firebaseConfig = brand === 'superstory' ? superstoryFirebaseConfig : rocnovelFirebaseConfig
